module.exports = __webpack_public_path__ + "static/media/text_icon_3.4e74ecf9.svg";